import { defaultTheme, OptionType, Typography } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import styled from 'styled-components'

const StyledOption = styled.div`
  white-space: normal;
`

const Label = styled.div`
  ${Typography.bodyLarge}
`

const Address = styled.div`
  ${Typography.bodyLarge}
  color: ${defaultTheme.color.textSecondary60a};
`

export const BidOption: FC<{ option: OptionType }> = ({ option }) => {
  return (
    <StyledOption>
      <Label>{option.label}</Label>
      <Address>{option.dto.address.address}</Address>
    </StyledOption>
  )
}
